import React from 'react'
import { connect } from 'react-redux'

class AuthToken extends React.Component {
  render() {
    let { csrfToken } = this.props
    if (!csrfToken && typeof document !== 'undefined') {
      const tokenDom = document.querySelector('meta[name=csrf-token]')
      csrfToken = tokenDom && tokenDom.getAttribute('content')
    }

    if (csrfToken) {
      return <input type="hidden" name="authenticity_token" value={csrfToken} />
    }
    return null
  }
}

export default connect(({ auth }) => ({
  csrfToken: auth.csrfToken,
}))(AuthToken)
